import actions from './actions'

export default function QualityControlsReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        editing: null,
        saveSuccess: false,
      }
    case actions.LIST_QUALITYCONTROL:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_QUALITYCONTROL:
      console.log('EDIT_QUALITYCONTROL', action)
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
        openModal: action.openModal,
      }
    case actions.RESET_QUALITYCONTROL:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
        openModal: null,
      }
    case actions.NEW_QUALITYCONTROL:
      return {
        ...state,
        editing: { qualityControlID: 0 },
        loading: false,
        saveSuccess: false,
        openModal: true,
      }
    case actions.CREATE_QUALITYCONTROL_RECIEVED ||
      actions.UPDATE_QUALITYCONTROL_RECIEVED ||
      actions.DELETE_QUALITYCONTROL_RECIEVED:
      return {
        ...state,
        editing: { qualityControlID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
